<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
    <v-dialog v-model="handleDialog" width="1000" class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center text-h5"><slot name="message"></slot></v-card-title>
                <v-card-text
                    class="common-dialog-message"
                >
                <v-container>
                    <v-row>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>氏名</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-text-field outlined clearable v-disabled-icon-focus disabled v-model="alertItem.name" background-color="white"></v-text-field>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>メールアドレス</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-text-field required outlined disabled v-model="alertItem.email" background-color="white"></v-text-field>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>グループ管理者</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="alertTeam"
                                inset
                                :label="alertTeam? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>書類管理者</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="alertDocument"
                                inset
                                :label="alertDocument? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>親展書類管理者</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="alertConfidential"
                                inset
                                :label="alertConfidential? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk">
                    <slot name="ok-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            alertItem: this.item, // 子で親のインスタンスを更新するので、一度変数に移す（オブジェクトだが大丈夫か？）
            password: '',
        };
    },
    props: {
        item: {
            id: Number,
            name: String,
            email: String,
            team_administrator_privileges: Number,
            document_manager: Number,
            confidential_document_manager: Number,
        },
        // ダイアログの開閉
        detailDialog: Boolean,
    },
    computed: {
        handleDialog: {
            get() {
                return this.detailDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:detailDialog', value);
            }
        },
        // オブジェクトの場合はプロパティをバインド（ v-model="alertItem.memo"等）してもリアクティブにならないのでgetter setterを定義してバインドが必要。
        alertTeam: {
            get() {
                return this.alertItem.team_administrator_privileges;
            },
            set(value) {
                this.alertItem.team_administrator_privileges = value;
            }
        },
        alertDocument: {
            get() {
                return this.alertItem.document_manager;
            },
            set(value) {
                this.alertItem.document_manager = value;
            }
        },
        alertConfidential: {
            get() {
                return this.alertItem.confidential_document_manager;
            },
            set(value) {
                this.alertItem.confidential_document_manager = value;
            }
        },
    },
    methods: {
        // 更新
        pushOk: function() {
            axios.post('/documents/update-organization-users/' + this.alertItem.id, {
                team_administrator_privileges: this.alertTeam,
                document_manager: this.alertDocument,
                confidential_document_manager: this.alertConfidential,
            }).then(res => {
                // 親コンポーネントへの通知
                if (res.data.success) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
              // console.log(res);
                this.success = false;
                this.message = "処理に失敗しました";
            }).finally(() => {
            });
        },
    },
};
</script>